/*
  snippets/options-swatches.liquid
  Powers two independent, mutually-exclusive PDP states:
   - initModal: the "SELECT STONE" trigger + picker modal -- builds the
     product-card grid and intention/colour filter chips from JSON (not
     server-rendered HTML), so the picker's payload stays small regardless of
     how large the source collection is. Page 1 (~50 products) is inlined by
     snippets/options-swatches.liquid; any remaining pages are fetched here in
     the background, after window "load", from
     sections/options-swatches-product-json.liquid via the Section Rendering
     API -- that's its own lean section (JSON only, no photos/description),
     chosen specifically so a background fetch never re-renders the whole
     (much heavier) PDP section just to get the rest of the stone list.
   - initCarousel: the fallback product-card carousel for products with no
     trigger+modal match -- a plain horizontal-scroll div (no Flickity/any
     library) with a feathered fade edge + prev/next arrows. Still
     server-rendered HTML (out of scope for the JSON-ification above).
   - initFavorites: the "Customer favorites" carousel on bracelet pages,
     layered on top of initModal (same modal, extra triggers) and reusing
     initCarousel for its card row.
  Cards in both are plain <a href> elements pointing at each product's URL,
  so navigation itself needs no JS. Plain JS (not jQuery) so it doesn't
  depend on load order relative to the theme's jQuery bundle.
*/
(function () {
  "use strict";

  var root = document.querySelector("[data-stonesel-root]");
  if (root) {
    initModal(root);
    initFavorites(root);
  }

  var carouselRoot = document.querySelector("[data-stonesel-carousel-root]");
  if (carouselRoot) initCarousel(carouselRoot);

  function initModal(root) {
  // More than one trigger can open the same modal: the SELECT STONE dropdown
  // and the "Customer favorites" carousel's "All bracelets" pill
  // and end-of-carousel card (see initFavorites below).
  var openBtns = Array.prototype.slice.call(root.querySelectorAll("[data-stonesel-open]"));
  var modal = root.querySelector(".stonesel-modal");
  var scrim = root.querySelector(".stonesel-scrim");

  // Reparent the modal + scrim to <body>, inside a fresh ".stonesel" wrapper
  // so the ".stonesel .stonesel-xxx" selectors and --ss-* custom properties
  // (assets/options-swatches-picker.css) still apply to them.
  //
  // On PDP this snippet renders inside the theme's off-canvas "shifter-page"
  // wrapper, which needs a transform to slide for the nav/cart drawer. Per
  // spec, a transformed ancestor becomes the containing block for any
  // position:fixed descendant, which traps this modal's stacking order
  // inside that ancestor instead of the real viewport/document stack -- so
  // #shopify-section-header .scrollheader (z-index:9999, assets/stylesheet.css)
  // was winning over this modal regardless of its own (much higher) z-index.
  // The older popup this replaced hit the same issue and used the same fix:
  // see theme-product.js.liquid's `$(".options-sw-wrapper-popupoverlay").
  // prependTo('body')`.
  if (modal && scrim) {
    var pickerWrap = document.createElement("div");
    pickerWrap.className = "stonesel";
    pickerWrap.appendChild(scrim);
    pickerWrap.appendChild(modal);
    document.body.appendChild(pickerWrap);
  }

  var grid = modal ? modal.querySelector("[data-stonesel-grid]") : null;
  var cards = []; // built from JSON below, not read off pre-rendered DOM
  var resultEl = modal ? modal.querySelector("[data-stonesel-resultcount]") : null;
  var clearBtn = modal ? modal.querySelector("[data-stonesel-clearfilters]") : null;
  var chipGroups = modal ? Array.prototype.slice.call(modal.querySelectorAll("[data-stonesel-chips]")) : [];

  var closeEls = [];
  if (scrim) closeEls.push(scrim);
  if (modal) closeEls = closeEls.concat(Array.prototype.slice.call(modal.querySelectorAll("[data-stonesel-close]")));

  var fIntent = "", fColor = "";

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function findChipGroup(kind) {
    return chipGroups.filter(function (g) { return g.dataset.stoneselChips === kind; })[0];
  }

  // Both chip rows render with only their "All ..." button and [hidden]
  // (snippets/options-swatches.liquid) -- one button is added per
  // intention/colour actually found in the loaded product JSON, and the row
  // is revealed the first time that happens.
  function ensureIntentionChip(value) {
    var group = findChipGroup("intention");
    if (!group || !value) return;
    var exists = Array.prototype.some.call(group.querySelectorAll("button"), function (b) {
      return b.dataset.filterIntention === value;
    });
    if (!exists) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "stonesel-chip";
      btn.dataset.filterIntention = value;
      btn.setAttribute("aria-pressed", "false");
      btn.textContent = value;
      group.appendChild(btn);
    }
    group.hidden = false;
  }
  function ensureColorChip(value) {
    var group = findChipGroup("color");
    if (!group || !value) return;
    var exists = Array.prototype.some.call(group.querySelectorAll("button"), function (b) {
      return b.dataset.filterColor === value;
    });
    if (!exists) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "stonesel-chip";
      btn.dataset.filterColor = value;
      btn.setAttribute("aria-pressed", "false");
      btn.textContent = value.replace(/-/g, " ").replace(/^./, function (c) { return c.toUpperCase(); });
      group.appendChild(btn);
    }
    group.hidden = false;
  }

  // Builds one .stonesel-card from a product JSON object -- the same markup
  // snippets/options-swatches-product-json-emit.liquid describes, just built
  // client-side now instead of server-rendered.
  function buildCard(p) {
    var a = document.createElement("a");
    a.href = p.url;
    a.className = "stonesel-card" + (p.active ? " stonesel-card--active" : "");
    a.setAttribute("data-stonesel-card", "");
    a.dataset.intentions = (p.intentions || []).join("||");
    a.dataset.color = p.color || "";
    a.dataset.hex = p.hex || "";

    var html = "";
    if (p.image) {
      html += '<span class="stonesel-card-image-wrap">' +
        '<img class="stonesel-card-image" src="' + esc(p.image) + '" width="400" height="400" alt="' + esc(p.name) + '" loading="lazy">' +
        '<span class="stonesel-card-image-overlay" aria-hidden="true"></span>' +
        (p.gem_badges || "") + // server-rendered snippets/gem-collection-badges.liquid markup
        '</span>';
    }
    html += '<span class="stonesel-card-name">' + esc(p.name) + '</span>';
    if (p.intentions && p.intentions.length) {
      html += '<span class="stonesel-card-intentions">' + esc(p.intentions.join(" · ")) + '</span>';
    }
    html += '<span class="stonesel-card-price">' + esc(p.price) + '</span>';
    if (p.active) html += '<span class="stonesel-card-active-badge">Viewing</span>';
    a.innerHTML = html;
    return a;
  }

  function addProducts(list) {
    if (!grid || !list) return;
    list.forEach(function (p) {
      var card = buildCard(p);
      grid.appendChild(card);
      cards.push(card);
      (p.intentions || []).forEach(ensureIntentionChip);
      ensureColorChip(p.color);
    });
  }

  /* ---------- page 1 (inline) + pages 2+ (background) --------------------
     snippets/options-swatches-product-json-emit.liquid wraps its loop in
     {% paginate %} because collection.products hard-caps at 50 items --
     source collections here (e.g. gemstone-bracelets) run to ~150 products,
     which is what used to leave the grid silently missing everything past
     the first page. Page 1 is inlined by snippets/options-swatches.liquid
     (read straight out of the DOM below); any remaining pages are fetched
     here, after window "load", from
     sections/options-swatches-product-json.liquid -- see that file for why
     it's a separate, much smaller section than product-template. */
  var initialDataEl = document.querySelector("[data-stonesel-products]");
  var totalPages = initialDataEl ? parseInt(initialDataEl.dataset.stoneselTotalPages, 10) || 1 : 1;
  var sectionMarker = document.querySelector("[data-stonesel-json-section-id]");
  var sectionId = sectionMarker ? sectionMarker.dataset.stoneselJsonSectionId : null;
  var pagesRequested = false;

  if (initialDataEl) {
    try { addProducts(JSON.parse(initialDataEl.textContent)); } catch (e) { /* malformed page-1 JSON -- leave the grid empty rather than throw */ }
  }

  function fetchRemainingPages() {
    if (pagesRequested || totalPages <= 1 || !sectionId) return;
    pagesRequested = true;

    var page = 2;
    function next() {
      if (page > totalPages) return;
      var url = window.location.pathname + "?section_id=" + encodeURIComponent(sectionId) + "&page=" + page;
      fetch(url, { credentials: "same-origin" })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var frag = document.createElement("div");
          frag.innerHTML = html;
          var el = frag.querySelector("[data-stonesel-products]");
          if (el) {
            addProducts(JSON.parse(el.textContent));
            // Applied after every page (not just once at the end) so that if
            // the customer opens the modal while this is still running,
            // cards already fetched show up immediately instead of
            // everything popping in at once when the last page lands.
            upgradeColorChipsToSwatches();
            applyFilters();
            updateFades();
          }
        })
        .catch(function (err) {
          console.error("[options-swatches] failed to load page " + page, err);
        })
        .then(function () { page++; next(); });
    }
    next();
  }

  // Kick off the background load once the page has finished loading (not on
  // script parse) so these requests never compete with the PDP's own
  // first-load resources (photos, fonts, apps) -- by the time a visitor
  // notices the trigger and opens the modal, the full set is normally
  // already in place. open() below still calls fetchRemainingPages() too, as
  // a fallback for the rare case a customer opens the modal before the load
  // event has fired.
  if (document.readyState === "complete") {
    fetchRemainingPages();
  } else {
    window.addEventListener("load", fetchRemainingPages);
  }

  // Same feathered-edge treatment as the bundle builder's filter chip rows
  // (assets/bracelet-builder.js updateFade/updateFades): only mask the side
  // that still has content scrolled off-screen.
  function updateFade(el) {
    var max = el.scrollWidth - el.clientWidth;
    el.classList.toggle("stonesel-fade-l", el.scrollLeft > 2);
    el.classList.toggle("stonesel-fade-r", el.scrollLeft < max - 2);
  }
  function updateFades() { chipGroups.forEach(updateFade); }

  // Average a set of hex colours by channel -- not every collection this
  // snippet serves has custom.bead_hex populated (that field's home is the
  // bundle builder's bracelet catalog), so this only needs to combine
  // whatever real hexes exist within one already tag-defined colour group,
  // not perceptually merge across different colour names the way
  // bracelet-builder.js's buildColorGroups() does.
  function meanHex(hexes) {
    var totals = [0, 0, 0];
    hexes.forEach(function (hex) {
      var h = hex.replace("#", "");
      if (h.length === 3) h = h.split("").map(function (c) { return c + c; }).join("");
      if (h.length !== 6) return;
      [0, 2, 4].forEach(function (pos, i) {
        var v = parseInt(h.substr(pos, 2), 16);
        if (!isNaN(v)) totals[i] += v;
      });
    });
    return "#" + totals.map(function (v) {
      return Math.round(v / hexes.length).toString(16).padStart(2, "0");
    }).join("");
  }

  // Upgrades a colour chip from a plain text pill into a real colour dot
  // (assets/options-swatches-picker.css .stonesel-chip--swatch), but only
  // when at least one product behind it actually has custom.bead_hex set.
  // Chips with no hex data anywhere in their group are left as text pills.
  function upgradeColorChipsToSwatches() {
    var colorGroup = chipGroups.filter(function (g) { return g.dataset.stoneselChips === "color"; })[0];
    if (!colorGroup) return;

    var hexByColor = {};
    cards.forEach(function (card) {
      var hex = card.dataset.hex, color = card.dataset.color;
      if (!hex || !color) return;
      (hexByColor[color] = hexByColor[color] || []).push(hex);
    });

    colorGroup.querySelectorAll("button[data-filter-color]").forEach(function (btn) {
      var key = btn.dataset.filterColor;
      if (!key) return; // the "All colors" chip stays as-is
      var hexes = hexByColor[key];
      if (!hexes || !hexes.length) return;
      var label = btn.textContent;
      btn.textContent = "";
      btn.classList.add("stonesel-chip--swatch");
      btn.style.backgroundColor = meanHex(hexes);
      btn.title = label;
      btn.setAttribute("aria-label", label);
    });
  }

  function open() {
    if (!modal || !scrim) return;
    modal.classList.add("stonesel-on");
    scrim.classList.add("stonesel-on");
    updateFades();
    fetchRemainingPages();
  }
  function close() {
    if (!modal || !scrim) return;
    modal.classList.remove("stonesel-on");
    scrim.classList.remove("stonesel-on");
  }

  function applyFilters() {
    var visible = 0;
    cards.forEach(function (card) {
      var intents = (card.dataset.intentions || "").split("||").filter(Boolean);
      var color = card.dataset.color || "";
      var matchIntent = !fIntent || intents.indexOf(fIntent) !== -1;
      var matchColor = !fColor || color === fColor;
      var show = matchIntent && matchColor;
      card.hidden = !show;
      if (show) visible++;
    });
    if (grid) grid.classList.toggle("stonesel-isempty", visible === 0);
    if (resultEl) {
      resultEl.innerHTML = "<b>" + visible + "</b> " + (root.dataset.itemsLabel || (visible === 1 ? "stone" : "stones"));
    }
    if (clearBtn) clearBtn.hidden = !(fIntent || fColor);
  }

  chipGroups.forEach(function (group) {
    var isIntent = group.dataset.stoneselChips === "intention";
    group.addEventListener("click", function (e) {
      var btn = e.target.closest("button");
      if (!btn) return;
      var value = isIntent ? btn.dataset.filterIntention : btn.dataset.filterColor;
      if (isIntent) fIntent = value || ""; else fColor = value || "";
      group.querySelectorAll("button").forEach(function (b) { b.setAttribute("aria-pressed", b === btn); });
      applyFilters();
    });
  });

  if (clearBtn) {
    clearBtn.addEventListener("click", function () {
      fIntent = ""; fColor = "";
      chipGroups.forEach(function (group) {
        var isIntent = group.dataset.stoneselChips === "intention";
        group.querySelectorAll("button").forEach(function (b) {
          var val = isIntent ? b.dataset.filterIntention : b.dataset.filterColor;
          b.setAttribute("aria-pressed", val === "");
        });
      });
      applyFilters();
    });
  }

  openBtns.forEach(function (btn) { btn.addEventListener("click", open); });
  closeEls.forEach(function (el) { el.addEventListener("click", close); });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    // Escape while the gem badge popup is open should only close that popup.
    var gemPopup = document.getElementById("gem-collection-popup");
    if (gemPopup && gemPopup.open) return;
    close();
  });

  chipGroups.forEach(function (el) {
    el.addEventListener("scroll", function () { updateFade(el); }, { passive: true });
  });
  window.addEventListener("resize", updateFades);

  upgradeColorChipsToSwatches();
  applyFilters();
  }

  // Same feathered-edge + arrow-visibility logic driven by real scroll
  // position -- no external carousel library, this is a plain overflow-x
  // div (assets/options-swatches-picker.css .stonesel-carousel-track).
  function initCarousel(carouselRoot) {
    var track = carouselRoot.querySelector("[data-stonesel-carousel-track]");
    var prevBtn = carouselRoot.querySelector("[data-stonesel-carousel-prev]");
    var nextBtn = carouselRoot.querySelector("[data-stonesel-carousel-next]");
    if (!track) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= max - 2;
      track.classList.toggle("stonesel-carousel-fade-l", !atStart);
      track.classList.toggle("stonesel-carousel-fade-r", !atEnd);
      if (prevBtn) prevBtn.hidden = atStart;
      if (nextBtn) nextBtn.hidden = atEnd;
    }

    // Step = one card plus the space after it. The bracelet-set cards space
    // themselves with margin-right:7px; the favorites track uses a CSS gap.
    function scrollByDir(dir) {
      var card = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 7;
      var step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * step * 2, behavior: "smooth" });
    }

    if (prevBtn) prevBtn.addEventListener("click", function () { scrollByDir(-1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { scrollByDir(1); });
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    update();
  }

  /* ---------- Customer favorites carousel ----------
     The winning carousel uses the existing stone drawer and plain product
     links. Initialize it without waiting for experiment assignment so every
     bracelet visitor gets the same feature, including when Intelligems is
     unavailable. Without JavaScript the original stone trigger remains. */
  function initFavorites(root) {
    var favs = root.querySelector("[data-stonesel-favs]");
    if (!favs) return;

    root.classList.add("stonesel--favs");
    favs.hidden = false;
    var carousel = favs.querySelector("[data-stonesel-favs-carousel]");
    if (carousel) initCarousel(carousel);
    bindFavsTracking(favs);
  }

  // One click event per card (plus the two "see all" openers) so the test
  // reads in GA4 (gtag when present, and the GTM dataLayer), Heatmap.com and
  // Intelligems custom events. Each sink is optional and guarded -- a missing
  // or broken tracker must never block the card's own navigation.
  function favsTrack(name, params) {
    var payload = { event: name, cf_test: "customer_favorites_carousel" };
    Object.keys(params).forEach(function (k) { payload[k] = params[k]; });
    try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) { /* ignore */ }
    try { if (typeof window.gtag === "function") window.gtag("event", name, params); } catch (e) { /* ignore */ }
    try { if (window._heatmap_paq) window._heatmap_paq.push(["trackEvent", "Customer favorites", name, params.product_handle || params.source || ""]); } catch (e) { /* ignore */ }
    try { (window.igEvents = window.igEvents || []).push({ event: name }); } catch (e) { /* ignore */ }
  }

  function bindFavsTracking(favs) {
    var pageHandle = (window.location.pathname.split("/products/")[1] || "").split(/[/?#]/)[0];
    favs.addEventListener("click", function (e) {
      var card = e.target.closest("[data-stonesel-favs-card]");
      if (card) {
        favsTrack("customer_favorites_card_click", {
          product_id: card.dataset.productId,
          product_handle: card.dataset.productHandle,
          position: parseInt(card.dataset.position, 10) || 0,
          source_product_handle: pageHandle
        });
        return;
      }
      var opener = e.target.closest("[data-stonesel-favs-open]");
      if (opener) {
        favsTrack("customer_favorites_see_all", {
          source: opener.dataset.stoneselFavsOpen,
          source_product_handle: pageHandle
        });
      }
    });
  }
})();
